import { render, staticRenderFns } from "./PickingMat.vue?vue&type=template&id=ae0865b6"
import script from "./PickingMat.vue?vue&type=script&lang=js"
export * from "./PickingMat.vue?vue&type=script&lang=js"
import style0 from "./PickingMat.vue?vue&type=style&index=0&id=ae0865b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports